export const EMPTY_VALUE_PLACEHOLDER = '*';

export const formatNumber = (value: number | null, digits = 2): string => {
  if (value === null || Number.isNaN(value)) {
    return EMPTY_VALUE_PLACEHOLDER;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: value % 1 === 0 ? 0 : Math.min(2, digits),
    maximumFractionDigits: digits,
  });
  return formatter.format(value);
};

export const formatCount = (value: number): string => value.toLocaleString('en-US');

export const formatPercent = (value: number | null): string => {
  if (value === null || Number.isNaN(value)) {
    return EMPTY_VALUE_PLACEHOLDER;
  }
  return `${formatNumber(value, 2)}%`;
};
